import React from 'react';
import { compose } from 'ramda';
import connect from 'react-redux/es/connect/connect';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import Image from '@synergycms_core/components/generic/Image';

import LoyaltyModal from '../Modal/index';

export const LoyaltyPublic = ({ theme : { styles : { classes }}, hotelName, loyaltyUser, customerForm}) => {

  return (
    <div className={classes.public}>
      <div className={[classes.starLogo, customerForm ? classes.customerFormLogo : ''].join(' ')}>
        <Image svg={'memberOnlyWhite'}/>
      </div>
      <div className="title">
        <RichText translate={true}
          dangerouslySetInnerHTML={true}
          withVars={{NOMBREHOTEL: hotelName}}
          text={'_%consigue ventajas fidelizacion%_'}
          ucFirst={true}
          innerStyle={classes.starTabTitle}/>
      </div>
      <ul className={["text", customerForm ? "customerFormText" : ''].join(' ')}>
        <li>
          <Image svg={'piggyBank'}/>
          <div>
            <b><RichText text={'_%mejor fidelizacion%_'} innerStyle={['roboto13Black']} translate={true} ucFirst={true} /></b>
            <RichText text={'_%precio fidelizacion%_'} innerStyle={['roboto13BoldBlack']} translate={true}/>
          </div>
        </li>
        <li>
          <Image svg={'discountTag'}/>
          <div>
            <b><RichText text={'_%descuentos fidelizacion%_'} innerStyle={['roboto13BoldBlack']} translate={true} ucFirst={true} /></b>
            <RichText text={'_%exclusivos fidelizacion%_'} innerStyle={['roboto13Black']} translate={true}/>
          </div>
        </li>
        <li>
          <div className={classes.colorDiamond}>
          <Image svg={'diamond'}/>
          </div>
          <div>
            <b><RichText text={'_%servicios fidelizacion%_'} innerStyle={['roboto13BoldBlack']} translate={true} ucFirst={true} /></b>
            <RichText text={'_%adicionales fidelizacion%_'} innerStyle={['roboto13Black']} translate={true}/>
          </div>
        </li>
      </ul>
      <div className={classes.flex}>
        <LoyaltyModal view={'register'}>
          <Button
            richText={{
              text: '_%register fidelizacion%_',
              ucFirst: true,
              innerStyle: ['uppercase'],
              translate: true
            }}
            innerStyle={['toggleSecondButton', classes.buttonRegister]}
            rightIcon={{
              content: <svg id="Grupo_17" data-name="Grupo 17" width="14.103" height="14.103" viewBox="0 0 14.103 14.103">
              <defs>
                <clipPath id="clip-path">
                  <rect id="Rectángulo_11" data-name="Rectángulo 11" width="14.103" height="14.103" fill="#36404e"/>
                </clipPath>
              </defs>
              <g id="Grupo_16" data-name="Grupo 16" clip-path="url(#clip-path)">
                <path id="Trazado_15" data-name="Trazado 15" d="M7.551,0c.194.027.389.051.583.082a6.952,6.952,0,0,1,4.2,2.3A6.736,6.736,0,0,1,13.971,5.7,6.88,6.88,0,0,1,12.4,11.639a6.714,6.714,0,0,1-4.012,2.333,6.859,6.859,0,0,1-5.921-1.581A6.744,6.744,0,0,1,.129,8.364,6.852,6.852,0,0,1,1.557,2.647,6.852,6.852,0,0,1,5.824.11c.243-.044.488-.073.732-.11ZM2.619,11.387A4.549,4.549,0,0,1,5.383,8.335,2.84,2.84,0,1,1,8.9,3.884,2.757,2.757,0,0,1,9.886,5.9,2.818,2.818,0,0,1,8.719,8.333a4.544,4.544,0,0,1,2.768,3.051,6.207,6.207,0,1,0-8.868,0M7.063,8.84c-.317.048-.639.074-.95.148a3.64,3.64,0,0,0-2.747,2.951.153.153,0,0,0,.086.174,6.215,6.215,0,0,0,6.919.191c.426-.265.424-.268.287-.756a3.766,3.766,0,0,0-3.6-2.708m0-.812a2,2,0,1,0-2-1.983,1.989,1.989,0,0,0,2,1.983" transform="translate(0)" fill="#36404e"/>
              </g>
            </svg>,
              innerStyle: [classes.loyaltyIcon]
            }}
          />
        </LoyaltyModal>
        <LoyaltyModal view={'login'}>
          <Button
            richText={{ text: '_%login fidelizacion%_', ucFirst: true, innerStyle: ['uppercase'], translate: true }}
            innerStyle={['toggleSecondButton', classes.buttonLogin].join(' ')}
            rightIcon={{
              content: <svg width="14.103" height="14.71" viewBox="0 0 14.103 14.71">
              <g id="Grupo_19" data-name="Grupo 19" transform="translate(14.103 14.71) rotate(180)">
                <g id="Grupo_19-2" data-name="Grupo 19">
                  <path id="Trazado_16" data-name="Trazado 16" d="M2.606,5.205a.481.481,0,0,1-.341-.142C1.535,4.351.822,3.638.147,2.943a.473.473,0,0,1,0-.687C.856,1.529,1.569.816,2.267.138A.482.482,0,0,1,2.605,0a.528.528,0,0,1,.371.156A.5.5,0,0,1,2.99.868c-.188.2-.4.391-.6.577-.091.084-.182.168-.271.253l-.4.4,2.581,0H6.026c1.318,0,2.328,0,3.278-.011H9.32a.745.745,0,0,1,.732.338v.363a.748.748,0,0,1-.733.338H9.3c-.944-.007-1.948-.011-3.257-.011H4.325l-2.573,0,.375.374.258.247c.19.181.387.369.571.56a.571.571,0,0,1,.17.413.5.5,0,0,1-.168.354.525.525,0,0,1-.352.141" transform="translate(4.051 4.751)" fill="#36404e"/>
                  <path id="Trazado_17" data-name="Trazado 17" d="M4.939,14.71q-1.593,0-3.186,0A1.783,1.783,0,0,1,0,12.95c0-1.295,0-2.612,0-3.885,0,0,0-1.18,0-1.745V5.667Q0,3.75,0,1.833A1.787,1.787,0,0,1,1.821,0H8.028A1.79,1.79,0,0,1,9.853,1.829c0,.792,0,1.579,0,2.338,0,.307-.151.485-.413.488H9.433c-.347,0-.42-.269-.421-.495q0-.5,0-.993,0-.615,0-1.231A.994.994,0,0,0,7.926.843H1.92A.988.988,0,0,0,.844,1.915c0,3.886,0,7.448,0,10.887A.985.985,0,0,0,1.9,13.864l3.018,0,3.018,0A.991.991,0,0,0,9.011,12.79c0-.445,0-.891,0-1.336v-.035q0-.427,0-.854c0-.338.14-.51.415-.512.352,0,.426.271.426.5v.364c0,.666,0,1.354,0,2.031A1.788,1.788,0,0,1,8.1,14.706q-1.582,0-3.165,0" transform="translate(0)" fill="#36404e"/>
                </g>
              </g>
            </svg>,
              innerStyle: [classes.loyaltyIcon]
            }}
          />
        </LoyaltyModal>
      </div>
    </div>
  );
}

const mapStateToProps = (store) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotel = store.getIn(['hotels', hotelId], undefined);

  return {
    hotelName : hotel.get('name'),
    loyaltyUser: store.getIn(['customer', 'loyalty', 'user'], null),
  };
};

export default compose(connect(mapStateToProps), withThemeJSS({ styleFile, link: true }), withContent('i18n'))(LoyaltyPublic);


